import { MuiCheckbox } from "@/modules/leads/components/leads-table/components/body/components/checkbox";
import { Box, Typography } from "@mui/material";

const BecomeFranchiseToggle = ({
  isBecomeFranchiseOnly,
  setIsBecomeFranchiseOnly,
}: {
  isBecomeFranchiseOnly: boolean;
  setIsBecomeFranchiseOnly: (isBecomeFranchiseOnly: boolean) => void;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: "fit-content",
      }}
    >
      <MuiCheckbox
        checked={isBecomeFranchiseOnly}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setIsBecomeFranchiseOnly(e.target.checked)
        }
      />
      <Typography>Show "Become Franchise" Only</Typography>
    </Box>
  );
};

export default BecomeFranchiseToggle;
